import numeral from 'numeral';
import { Post } from '../Axios/AxiosFunctions';
import { apiHeader, BaseURL } from '../config/apiUrl';

// Area Converter
export const convertAreaIfNotInMeterSqaure = (param, areaUnit = 'm²') => {
  if (areaUnit == 'm²') {
    return Number(param);
  } else {
    return Number(ft2ToM2(param));
  }
};

export const m2ToFt2 = ({ area = 0, areaUnit = 'ft²', unit = true }) => {
  return `${areaUnit === 'ft²' ? (area * 10.7639).toFixed(2) : area}` + ` ${unit ? areaUnit : ''}`;
};
export const ft2ToM2 = (area) => {
  return parseInt(area / 10.7639);
};
// Currency Converter
export const usdToOther = ({ amount = 0, value = 0, symbol = '', isNumeral = true }) => {
  return `${symbol ? symbol + ' ' : ''}${
    isNumeral ? numeral(amount * value).format('0,0') : amount * value
  }`;
};
export const usdToOther2 = ({ amount = 0, value = 0, symbol = '', isNumeral = true }) => {
  return `${isNumeral ? numeral(amount * value).format('0,0') : amount * value}${
    symbol ? ' ' + symbol : ''
  }`;
};

export const validateEmail = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

// Other to usd
// Purpose: This function will be used for price searching because we have price in usd dollars in the database model
export const otherToUsd = ({ amount = 0, value = 0, unit }) => {
  return unit == 'USD' ? Number(amount) : Number(amount) * value;
};

// get unique browserID
export const getUniqueBrowserId = () => {
  const uniqueBrowserId = localStorage.getItem('uniqueBrowserId');
  if (uniqueBrowserId) {
    return uniqueBrowserId;
  }

  if (window.navigator) {
    var navigator_info = window.navigator;
    var screen_info = window.screen;
    var uid = navigator_info.mimeTypes.length;
    uid += navigator_info.userAgent.replace(/\D+/g, '');
    uid += navigator_info.plugins.length;
    uid += screen_info.height || '';
    uid += screen_info.width || '';
    uid += screen_info.pixelDepth || '';

    localStorage.setItem('uniqueBrowserId', uid);
    return uid;
  } else {
    const theId =
      Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    localStorage.setItem('uniqueBrowserId', theId);
    return theId;
  }
};

export const uploadImages = async (images, token) => {
  if (!images.length) return null;
  const formData = new FormData();
  images.forEach((image) => {
    formData.append('images', image);
  });

  const res = await Post(BaseURL('media/upload'), formData, apiHeader(token, true));

  if (res) {
    return res.data?.data;
  }

  return null;
};

export const uploadImagesHelper = async ({ images, setIsLoading, setImages, token }) => {
  if (images.length === 0) return;
  setIsLoading(true);
  uploadImages(images, token)
    .then((res) => {
      if (res) {
        setImages((prev) => [...prev, ...res]);
      }
      setIsLoading(false);
    })
    .finally(() => {
      setIsLoading(false);
    });
};

export const getSelectedLanguagePage = (selectedLanguage, cmsPages, pageName) => {
  if (cmsPages?.length === 0) return {};
  const langData = cmsPages?.find((p) => p?.locale === selectedLanguage);
  return langData[pageName];
};

export const getValue = (value = '', extra = ' ') => {
  const a = value;
  if (a) return `${value}${extra}`;
  return '';
};

export const generateBanners = ({ allBanners, routeName, page }) => {
  let _generatedBanners = [];
  if ([1, 2, 3, 4].includes(page)) {
    _generatedBanners = allBanners.filter(
      (item) =>
        item?.page === routeName && item?.bannerType == 'horizontal' && item?.pageNo === page
    );
  } else {
    const bannersWithoutPage = allBanners.filter(
      (item) => item?.page === routeName && item?.bannerType == 'horizontal' && item?.pageNo == null
    );
    if (bannersWithoutPage.length === 1) {
      // _generatedBanners = [bannersWithoutPage[0]];
      _generatedBanners = [...bannersWithoutPage];
    } else {
      const startIndex = (page - 5) % bannersWithoutPage.length;
      const nextIndex = (startIndex + 1) % bannersWithoutPage.length;
      _generatedBanners = [bannersWithoutPage[startIndex], bannersWithoutPage[nextIndex]];
    }
  }

  if (_generatedBanners?.length > 2) {
    _generatedBanners.length = 2;
  } else if (_generatedBanners?.length === 1) {
    _generatedBanners = [..._generatedBanners, ..._generatedBanners];
  }

  return _generatedBanners;
};

export const bannerConditions = {
  list: {
    renderCondition: (key) => key % 5 === 4 && ![0, 14].includes(key)
  },
  grid: {
    renderCondition: (key) => key % 6 === 5 && ![0, 14].includes(key)
  },
  renderContentCondition: (key) => Math.floor((key - 4) / 5)
};

export const isHTML = (str = '') => {
  if (!str) return false;
  const parser = new DOMParser();
  const doc = parser.parseFromString(str, 'text/html');
  return Array.from(doc.body.childNodes).some((node) => node.nodeType === 1);
};

export const mergeClass = (...classes) => {
  return classes.filter(Boolean).join(' ');
};
